import {graphql} from 'gatsby';
import React, {memo} from 'react';

import PageElementGroup from '../components/page-element-group';

export const query = graphql `
	query IndexPage {
		allPagesJson(filter: {slug: {eq: "homepage"}}) {
			nodes {
				...PageElementGroup
			}
		}
	}
`;

export default memo(
	/**
	 * @param {import("gatsby").PageProps<
	 *   import("../../tmp/graphql-types").IndexPageQuery,
	 *   {
	 *     hashState: number,
	 *     meta: import("../page-metadata").PageMetadata,
	 *   }
	 * >} props
	 * @returns {React.ReactElement} ...
	 */
	function IndexPage({data, pageContext: {hashState, meta}}) {
		return (
			<PageElementGroup
				name="main"
				nodes={data.allPagesJson.nodes}
				meta={meta}
				hashState={hashState}
			/>
		);
	}
);
